import React from 'react';
import { getText } from 'services/languageService';
import { ExportModalProps } from 'types/mainPage';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, IconButton, Typography } from '@mui/material';

const extButtons = [
  {
    title: 'PNG',
    id: 'png',
  },
  {
    title: 'PDF',
    id: 'pdf',
  },
  {
    title: 'XLSX',
    id: 'xlsx',
  },
];

export const ExportModal: React.FC<ExportModalProps> = ({
  handleClose,
  open,
  exportCb,
  ext = ['pdf', 'png', 'xlsx'],
  title = getText('EXPORT_MODAL_TITLE'),
  exportMapFile,
  hasMapFile,
}) => {
  const onExport = (ext: string) => {
    return exportCb(ext);
  };

  return open ? (
    <Box
      sx={{
        width: 200,
        p: 1,
        pt: 0,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '2px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography>{title}</Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      {hasMapFile && (
        <Box sx={{ display: 'flex', flexDirection: 'column', p: '0 8px' }}>
          <Typography>{getText('EXPORT_ALL_LAYER')}</Typography>
          <Button variant="outlined" onClick={exportMapFile} sx={{ mb: 1 }}>
            PDF
          </Button>
        </Box>
      )}

      <Box sx={{ display: 'flex', flexDirection: 'column', p: '0 8px' }}>
        <Typography>{getText('EXPORT_CURRENT_EXTENT')}</Typography>
        {extButtons.map((item) => {
          return ext.includes(item.id) ? (
            <Button
              variant="outlined"
              key={item.id}
              onClick={() => onExport(item.id)}
              sx={{ mb: 1 }}
            >
              {item.title}
            </Button>
          ) : (
            <></>
          );
        })}
      </Box>
    </Box>
  ) : null;
};
